import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { tryFetch, IResponse } from "../../../helpers/FetchAPI";
import GetTicketPage from "./index";
import GetTicketRequired from "./getTicketRequired";

const GetTicketWrapper: React.FC = () => {
  // const { id } = useParams();
  const { slug } = useParams();
  const [eventData, setEventData] = useState<any>(null);
  const location = useLocation();
  const eventId = location.state?.eventId;

  useEffect(() => {
    const load = async () => {
      const res: IResponse = await tryFetch({
        url: `/events/${eventId}`,
        method: "GET",
      });

      if (res.is_success && res.data) {
        setEventData(res.data);
      }
    };

    load();
  }, [slug]);

  if (!eventData) return <div>Loading...</div>;

  const requires = eventData.require_customer_data;

if (requires == 1 || requires == true || requires == "1") {
  return <GetTicketRequired />;
}

  return <GetTicketPage />;
};

export default GetTicketWrapper;
